<template>
    <div>
        <div class="p-4 text-center">
            <h2>
                Seleziona il modello
            </h2>
        </div>

        <pulse-loader :loading="loading"></pulse-loader>
        <div class="row" v-if="!loading">
            <div v-for="model in models" v-bind:key="model.id" class="col-lg-3 col-md-4 col-sm-6 col-12">
                <catalog-model-card :model="model" @click="onModelSelect(model)"></catalog-model-card>
            </div>
        </div>
    </div>
</template>

<script>
    import CatalogModelCard from './CatalogModelCard'
    import BaseCatalogModelList from '../../components/base/BaseCatalogModelList'
    import CatalogModel from '../mixins/CatalogModel'

    export default {
        extends: BaseCatalogModelList,

        props: {
            catalog: {
                type: Boolean,
                required: false
            }
        },

        mixins: [CatalogModel],

        components: { CatalogModelCard },

        methods: {
            $_getBoatModels(params = {}) {
                this.loading = true
                this.getCatalogModels(this.$route.params.id, params)
                    .then(response => {
                        this.models = response.data.data
                        this.$_sortModels()
                        this.loading = false
                        this.ready = true
                    })
                    .catch(error => {
                        this.loading = false
                    })
            },

            onModelSelect(model) {
                this.$router.push({ name: 'model', params: { id: model.id } })
            }
        }
    }
</script>
